/*
 * @LastEditors: zhanglinju
 */

import pageMana from './pageMana/router'; // 站点管理
import templateMana from './templateMana/router'; // 模板管理
import authority from './authority/router'; // 权限管理
import contentManage from './pageFront/contentManage/router'; // 内容管理
import mobileManage from './mobile/router';
export const baseSale = () => import(/* webpackChunkName: "textproject" */ './base');
export default [
    {
        path: '/baseSale',
        name: 'baseSale',
        component: baseSale,
        meta: {
            documentTitle: '优学派-网页管理',
        },
        children: [
            ...pageMana,
            ...templateMana,
            ...authority,
            ...contentManage,
        ],
    },
    ...mobileManage,
];

export const menuItems = [
    {
        index: '/pageMana/pageDetail',
        label: '站点管理',
        class: 'icon-site',
        access: {
            actionsCode: ['04201001'],
            includeOrg: [],
            outsideOrg: [],
        },
        children: [],
    },
    {
        index: '/templateMana/templateDetail',
        label: '模板管理',
        class: 'icon-tpl',
        access: {
            actionsCode: ['04202001'],
            includeOrg: [],
            outsideOrg: [],
        },
        children: [],
    },
    {
        index: '/pageMana/authority',
        label: '权限管理',
        class: 'icon-auth',
        access: {
            actionsCode: ['04200001'],
            includeOrg: [],
            outsideOrg: [],
        },
    },
];
